import Link from "gatsby-link";
import * as React from "react";
import "./logo.scss";

class Logo extends React.Component<{}, {}> {
  public render() {
    return (
      <div className="logo">
        <Link to="/">
          <svg
            className="logo__svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 89 40"
          >
            <path
              d="M69.326 40c-.09 0-.208 0-.333-.004a.128.128 0 0 1-.118-.087l-1.869-5.202a.131.131 0 0 1 .015-.118.128.128 0 0 1 .105-.056h1.6c3.677.087 3.598-1.067 3.936-2.6.074-.338-9.239-23.952-9.239-23.952a.13.13 0 0 1 .013-.12.13.13 0 0 1 .106-.056h7.241c.054 0 .102.035.12.087l5.492 15.281 5.325-15.28a.128.128 0 0 1 .12-.087h6.813c.042 0 .081.021.105.056.024.035.03.08.014.12l-9.729 25.644C77.252 38.51 74.981 40 69.326 40zM23.535 10.162a9.59 9.59 0 0 0-6.78-2.768H7.108V.242A.245.245 0 0 0 6.868 0H.247a.247.247 0 0 0-.175.07A.24.24 0 0 0 0 .24v21.844c0 5.573 4.583 10.092 10.237 10.093l7.578.017c2.262 0 4.43-.885 6.03-2.462a8.346 8.346 0 0 0 2.496-5.944v-6.944a9.308 9.308 0 0 0-2.806-6.683zm-4.3 13.627a1.41 1.41 0 0 1-1.38 1.401l-7.617-.018c-.83 0-1.627-.325-2.215-.904a3.065 3.065 0 0 1-.917-2.183V14.4h9.652c1.368 0 2.478 1.095 2.478 2.444v6.946zm16.737 9.381h-6.579a.122.122 0 0 1-.088-.038.135.135 0 0 1-.037-.093V7.937a.13.13 0 0 1 .125-.132h6.579c.07 0 .126.06.126.132V33.04a.13.13 0 0 1-.126.132zm27.313 0H40.132a.132.132 0 0 1-.132-.13v-4.658c0-.032.011-.064.032-.089l12.213-14.281H40.838a.132.132 0 0 1-.131-.133V7.937c0-.072.058-.132.13-.132h19.166a.13.13 0 0 1 .122.089l1.839 4.73a.145.145 0 0 1 .009.049c0 .035-.01.07-.031.1l-12.3 14.542h11.47a.13.13 0 0 1 .123.085l2.172 5.588a.133.133 0 0 1-.122.177v.006zm25.495-2.453c0 1.374-1.056 2.454-2.43 2.454a2.424 2.424 0 0 1-2.448-2.454 2.425 2.425 0 0 1 2.446-2.424c1.36 0 2.432 1.08 2.432 2.424zm-4.268 0c0 1.08.781 1.937 1.852 1.937 1.041 0 1.809-.858 1.809-1.922 0-1.08-.768-1.951-1.823-1.951-1.056 0-1.838.871-1.838 1.936zm1.461 1.268h-.552v-2.421c.3-.054.606-.08.911-.074.448 0 .652.074.829.177a.678.678 0 0 1 .232.533c0 .266-.203.47-.493.564v.03c.232.088.362.266.435.591.071.37.116.517.174.606h-.594c-.073-.089-.116-.31-.184-.592-.044-.265-.184-.383-.493-.383h-.265v.97zm.015-1.375h.26c.304 0 .553-.103.553-.354 0-.222-.16-.37-.506-.37a1.335 1.335 0 0 0-.304.03l-.003.694z"
              fill="#FFF"
            />
          </svg>
        </Link>
        {/* These h1 and h2 must be repalced by site's metada when graphql queries are implemented */}
        <h1 className="sr-only">Bizy</h1>
        <h2 className="sr-only">Bizy homepage</h2>
      </div>
    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/logo/logo.tsx